import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AppBar, Toolbar, Box, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import authService from "../../services/auth/authService";
import Sidebar from "../../components/Shared/Sidebar";

const Home: React.FC = () => {
  const location = useLocation();
  
  const handleLogout = () => {
    authService.logout();
  };
  
  const menuItems = [
    {
          id: "shooting-data",
          label: "Shooting Data",
          icon: (
            <Box
              component="img"
              src="/shootingData/aim.svg"
              alt="Shooting Data"
              sx={{
                width: 24,
                height: 24,
                filter: location.pathname.includes("shooting-data")
                  ? "invert(56%) sepia(79%) saturate(276%) hue-rotate(148deg) brightness(93%) contrast(92%)"
                  : "invert(76%) sepia(1%) saturate(0%) hue-rotate(174deg) brightness(88%) contrast(92%)",
              }}
            />
          ),
          path: "shooting-data"
        },
    
    { id: "profile", label: "Profile", icon: <PersonIcon />, path: "/vcat-user/user-info" },
  ];

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#0D1117" }}>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100%)` },
          backgroundColor: "#161B22",
          boxShadow: "none",
        }}
      ></AppBar>

      <Sidebar menuItems={menuItems} onLogout={handleLogout} logoSrc="/logo.png" />

      <Box
  component="main"
  sx={{
    flexGrow: 1,
    width: { sm: `calc(100%)` },
    backgroundColor: "#0E1720",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  }}
>
  <Box sx={{ p: 4, flexGrow: 1 }}>
    <Toolbar />
    <Outlet />
  </Box>

  <Box sx={{ py: 2, textAlign: "center", width: "100%" }}>
    <Typography variant="caption" sx={{ color: "#A8B2D1" }}>
      © {new Date().getFullYear()} VCAT. All rights reserved.
    </Typography>
  </Box>
</Box>

    </Box>
  );
};

export default Home;
